/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import FormControlLabel from '@material-ui/core/FormControlLabel/FormControlLabel';
import Switch from '@material-ui/core/Switch/Switch';
import TextField from '@material-ui/core/TextField/TextField';
import FormAddress from 'packages/auth/register/FormAddress';
import {CreateTournamentForm as ICreateTournamentForm} from 'packages/common-types/base-types';
import {Tournament} from 'packages/common-types/schema-types';
import {
  REQUIRED_FIELD_MESSAGE,
  ROUND_NUMBERS,
  TOURNAMENT_CATEGORIES,
  TOURNAMENT_MODALITIES,
  TOURNAMENT_TYPE,
  TOURNAMENT_CAT,
} from 'packages/constants/constants';
import {useEffect, useState} from 'react';
import Select from 'react-select';
import {Controller, useFormContext} from 'react-hook-form';

type Props = {
  onSubmit: (formData: ICreateTournamentForm) => void;
  tournamentData?: Tournament;
};

const CreateTournamentForm = (props: Props) => {
  const {onSubmit, tournamentData} = props;
  const {handleSubmit, errors, register, control, setValue} =
    useFormContext<ICreateTournamentForm>();
  const checkKeyDown = (e: any) => e.code === 'Enter' && e.preventDefault();
  const [hasFinalState, setHasFinalState] = useState(false);

  const selectStyles = {
    menu: (provided: any) => ({
      ...provided,
      zIndex: 200,
    }),
  };

  useEffect(() => {
    if (tournamentData) {
      setValue('name', tournamentData.name);
      setValue('gender', tournamentData.conditions.gender);
      setValue('tournamentType', tournamentData.conditions.tournamentType);
      setValue('numberOfRounds', tournamentData.conditions.numberOfRounds);
      setValue('tournamentType', tournamentData.conditions.tournamentType);
      setValue(
        'tournamentCategory',
        tournamentData.conditions.tournamentCategory
      );
      setValue('modalityGame', tournamentData.conditions.modalityGame);
      setValue('pointLimit', tournamentData.conditions.pointLimit);
      setValue('country', tournamentData.address.country);
      setValue('state', tournamentData.address.state);
      setValue('city', tournamentData.address.city);
      setHasFinalState(tournamentData.hasFinal);
      setValue('startDate', tournamentData.startDate);
      setValue('finishDate', tournamentData.finishDate);
    }
  }, [tournamentData, setValue]);

  return (
    <>
      <form
        id="create-tournament-form"
        onKeyDown={checkKeyDown}
        onSubmit={handleSubmit(onSubmit)}
      >
        <TextField
          fullWidth
          label="Nombre"
          InputLabelProps={{shrink: true}}
          error={errors.name && true}
          helperText={errors.name?.message}
          name="name"
          variant="outlined"
          inputRef={register({
            required: {
              value: true,
              message: REQUIRED_FIELD_MESSAGE,
            },
          })}
          margin="dense"
        />

        <Controller
          name="gender"
          control={control}
          defaultValue={tournamentData?.conditions.gender}
          render={({ref, value, onChange, ...rest}) => (
            <div style={{marginTop: 8}}>
              <Select
                inputRef={ref}
                placeholder="Selecciona el género del torneo"
                getOptionValue={(item) => item.value}
                onChange={(newValue) => onChange(newValue.value)}
                value={TOURNAMENT_CATEGORIES.find(
                  (c) => c.value === value && c.value
                )}
                options={TOURNAMENT_CATEGORIES}
                {...rest}
              />
            </div>
          )}
        />

        <Controller
          name="tournamentType"
          control={control}
          defaultValue={tournamentData?.conditions.tournamentType}
          render={({ref, value, onChange, ...rest}) => (
            <div style={{marginTop: 8, marginBottom: 4}}>
              <Select
                inputRef={ref}
                placeholder="Tipo del torneo"
                getOptionValue={(item) => item.value}
                onChange={(newValue) => onChange(newValue.value)}
                value={TOURNAMENT_TYPE.find(
                  (c) => c.value === value && c.value
                )}
                options={TOURNAMENT_TYPE}
                {...rest}
              />
            </div>
          )}
        />

        <Controller
          name="tournamentCategory"
          control={control}
          defaultValue={tournamentData?.conditions.tournamentCategory}
          render={({ref, value, onChange, ...rest}) => (
            <div style={{marginTop: 8, marginBottom: 4}}>
              <Select
                inputRef={ref}
                placeholder="Categoria del torneo"
                getOptionValue={(item) => item.value}
                onChange={(newValue) => onChange(newValue.value)}
                value={TOURNAMENT_CAT.find((c) => c.value === value && c.value)}
                options={TOURNAMENT_CAT}
                {...rest}
              />
            </div>
          )}
        />

        <Controller
          name="numberOfRounds"
          control={control}
          defaultValue={tournamentData?.conditions.numberOfRounds}
          render={({ref, value, onChange, ...rest}) => (
            <div style={{marginTop: 8, marginBottom: 4}}>
              <Select
                inputRef={ref}
                styles={selectStyles}
                placeholder="Selecciona el numero de rondas del torneo"
                onChange={(newValue) => onChange(newValue.value)}
                value={ROUND_NUMBERS.find((c) => c.value === value && c.value)}
                options={ROUND_NUMBERS}
                {...rest}
              />
            </div>
          )}
        />

        <Controller
          name="modalityGame"
          control={control}
          defaultValue={tournamentData?.conditions.gender}
          render={({ref, value, onChange, ...rest}) => (
            <div style={{marginTop: 8, marginBottom: 4}}>
              <Select
                inputRef={ref}
                placeholder="Selecciona la modalidad del torneo"
                onChange={(newValue) => onChange(newValue.value)}
                getOptionValue={(item) => item.value}
                value={TOURNAMENT_MODALITIES.find(
                  (c) => c.value === value && c.value
                )}
                options={TOURNAMENT_MODALITIES}
                {...rest}
              />
            </div>
          )}
        />

        {/* Address Information */}
        {/* Country/State/City */}
        <FormAddress address={tournamentData?.address} />
        <TextField
          fullWidth
          label="Número de pintas"
          error={errors.pointLimit && true}
          helperText={errors.pointLimit?.message}
          name="pointLimit"
          variant="outlined"
          InputLabelProps={{shrink: true}}
          inputRef={register({
            required: {
              value: true,
              message: REQUIRED_FIELD_MESSAGE,
            },
          })}
          margin="dense"
        />
        <TextField
          fullWidth
          type="date"
          label="Fecha de inicio"
          name="startDate"
          variant="outlined"
          error={errors.startDate && true}
          helperText={errors.startDate?.message}
          margin="dense"
          inputRef={register({
            required: {
              value: true,
              message: REQUIRED_FIELD_MESSAGE,
            },
          })}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <TextField
          fullWidth
          error={errors.finishDate && true}
          helperText={errors.finishDate?.message}
          type="date"
          label="Fecha de fin"
          variant="outlined"
          name="finishDate"
          inputRef={register({
            required: {
              value: true,
              message: REQUIRED_FIELD_MESSAGE,
            },
          })}
          margin="dense"
          InputLabelProps={{
            shrink: true,
          }}
        />

        <FormControlLabel
          control={
            <Switch
              name="hasFinal"
              inputRef={register({})}
              inputProps={{'aria-label': 'secondary checkbox'}}
              onClick={() => {
                if (hasFinalState) {
                  setHasFinalState(false);
                } else {
                  setHasFinalState(true);
                }
              }}
              checked={hasFinalState}
            />
          }
          label="El torneo tiene final"
        />
      </form>
    </>
  );
};

CreateTournamentForm.defaultProps = {
  tournamentData: null,
};

export default CreateTournamentForm;
